import React, { FC } from 'react';

import { SessionViews } from 'src/common/types/WfaSessionViews';

import { MfaSessionAllIssues } from './all-issues/MfaSessionAllIssues';
import { MfaSessionOverview } from './overview/MfaSessionOverview';

interface IMfaSingleSessionTabContentProps {
	viewId: SessionViews;
	sessionId: string;
}

export const MfaSingleSessionTabContent: FC<IMfaSingleSessionTabContentProps> = ({
	viewId,
	sessionId
}) => {
	switch (viewId) {
		case SessionViews.OVERVIEW: {
			return <MfaSessionOverview sessionId={sessionId} />;
		}

		case SessionViews.ALL_ISSUES: {
			return <MfaSessionAllIssues sessionId={sessionId} />;
		}

		default:
			return null;
	}
};
